export default String.raw`
{% if products.PageQueryGET -%}
	{% assign pageQueryName = products.PageQueryGET -%}
    {% assign paginationPageCount = products.PageCount -%}
    {% assign paginationPageNo = products.PageNo -%}
    {% assign template = 'partials/products/products-list.html' -%}
    {% assign templateContainer = '.products-list-js' -%}
{% elseif blog.PostList.PageQueryGET -%}
	{% assign pageQueryName = blog.PostList.PageQueryGET -%} 
	{% assign paginationPageCount = blog.PostList.PageCount -%}
    {% assign paginationPageNo = blog.PostList.PageNo -%}
    {% assign template = 'static-elements/blog-container/blog-container.html' -%}
    {% assign templateContainer = '.blog-posts-list-js' -%}
{% elseif feedback.PageQueryGET -%}
	{% assign pageQueryName = feedback.PageQueryGET -%}
	{% assign paginationPageCount = feedback.PageCount -%}
    {% assign paginationPageNo = feedback.PageNo -%}
    {% assign template = 'partials/product/reviews-list.html' -%}
    {% assign templateContainer = '.reviews-list-js' -%}
{% elseif page.QueryString contains 'tab=wishlist-details' -%}
	{% assign additionalSubquery = true -%}
	{% assign currentSubqueryName = customer-profile.WishListsQueryGET -%}
	{% assign currentSubqueryValue =  customer-profile.WishListsProductsPagination.WishListId -%}
	{% assign pageQueryName = customer-profile.WishListsProductsPagination.PageQueryGET -%}
	{% assign wishListsTotalItems = customer-profile.WishListsProductsPagination.TotalItems -%}
	{% assign paginationPageCount = customer-profile.WishListsProductsPagination.TotalItems | DividedBy: 10 -%}
	{% assign paginationPageCountModulo = customer-profile.WishListsProductsPagination.TotalItems | Modulo: 10 -%}
	{% if paginationPageCountModulo <> 0 -%}
		{% assign paginationPageCount = paginationPageCount | Plus: 1 -%}
	{% endif -%}
	{% assign paginationPageNo = customer-profile.WishListsProductsPagination.PageNo -%}
	{% assign template = 'partials/wishlist/wishlist-table.html' -%}
	{% assign templateContainer = '.wishlist-table-js' -%}
    {% assign tab = 'wishlist-details' -%}
{% elseif page.QueryString contains 'tab=wishlist' -%}
	{% assign pageQueryName = customer-profile.WishListsPagination.PageQueryGET -%}
	{% assign wishListsTotalItems = customer-profile.WishListsPagination.TotalItems -%}
	{% assign paginationPageCount = customer-profile.WishListsPagination.TotalItems | DividedBy: 10 -%}
	{% assign paginationPageCountModulo = customer-profile.WishListsPagination.TotalItems | Modulo: 10 -%}
	{% if paginationPageCountModulo <> 0 -%}
		{% assign paginationPageCount = paginationPageCount | Plus: 1 -%}
	{% endif -%}
	{% assign paginationPageNo = customer-profile.WishListsPagination.PageNo -%}
	{% assign template = 'partials/wishlist/wishlists-list.html' -%}
	{% assign templateContainer = '.customer-wishlists-list-js' -%}
    {% assign tab = 'wishlist' -%}	
{% elseif page.QueryString contains 'tab=active-complaints' -%}
	{% assign pageQueryName = customer-profile.ComplaintsActive.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.ComplaintsActive.PageCount -%}
    {% assign paginationPageNo = customer-profile.ComplaintsActive.PageNo -%}
    {% assign template = 'partials/customer-profile/complaints/complaints-list.html' -%}
    {% assign templateContainer = '.complaints-js' -%}
    {% assign tab = 'active-complaints' -%}
{% elseif page.QueryString contains 'tab=executed-complaints' -%}
	{% assign pageQueryName = customer-profile.ComplaintsExecuted.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.ComplaintsExecuted.PageCount -%}
    {% assign paginationPageNo = customer-profile.ComplaintsExecuted.PageNo -%}
    {% assign template = 'partials/customer-profile/complaints/complaints-list.html' -%}
    {% assign templateContainer = '.complaints-js' -%}
    {% assign tab = 'executed-complaints' -%}
{% elseif page.QueryString contains 'tab=commented' -%}
	{% assign pageQueryName = customer-profile.Reviews.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Reviews.PageCount -%}
    {% assign paginationPageNo = customer-profile.Reviews.PageNo -%}
    {% assign template = 'partials/customer-profile/reviews/commented.html' -%}
    {% assign templateContainer = '.reviews-js' -%}
    {% assign tab = 'commented' -%}
{% elseif page.QueryString contains 'tab=to-comment' -%}
	{% assign pageQueryName = customer-profile.ProductsToRate.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.ProductsToRate.PageCount -%}
    {% assign paginationPageNo = customer-profile.ProductsToRate.PageNo -%}
    {% assign template = 'partials/customer-profile/reviews/to-comment.html' -%}
    {% assign templateContainer = '.reviews-js' -%}
    {% assign tab = 'to-comment' -%}
{% elseif page.QueryString contains 'tab=history' -%}
	{% assign pageQueryName = customer-profile.History.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.History.PageCount -%}
    {% assign paginationPageNo = customer-profile.History.PageNo -%}
    {% assign template = 'partials/customer-profile/your-account/history.html' -%}
    {% assign templateContainer = '.employee-data-js' -%}
    {% assign tab = 'history' -%}
{% elseif page.QueryString contains 'tab=loyalty-list' -%}
	{% assign pageQueryName = customer-profile.LoyaltyHistory.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.LoyaltyHistory.PageCount -%}
    {% assign paginationPageNo = customer-profile.LoyaltyHistory.PageNo -%}
    {% assign template = 'partials/customer-profile/loyalty-list/loyalty-list.html' -%}
    {% assign templateContainer = '.loyalty-history-js' -%}
	{% assign tab = 'loyalty-list' -%}
{% elseif page.QueryString contains 'tab=discounts' -%}
	{% assign pageQueryName = customer-profile.DiscountsERP.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.DiscountsERP.PageCount -%}
    {% assign paginationPageNo = customer-profile.DiscountsERP.PageNo -%}
    {% assign template = 'partials/customer-profile/discounts/discount-list.html' -%}
	{% assign templateContainer = '.discounts-list-js' -%}
	{% assign tab = 'discounts' -%}
{% elseif page.QueryString contains 'tab=coupons' -%}
	{% assign pageQueryName = customer-profile.Coupons.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Coupons.PageCount -%}
    {% assign paginationPageNo = customer-profile.Coupons.PageNo -%}
    {% assign template = 'partials/customer-profile/discounts/coupon-list.html' -%}
	{% assign templateContainer = '.coupons-list-js' -%}
	{% assign tab = 'coupons' -%}
{% elseif page.QueryString contains 'tab=coupon-details' -%}
	{% assign pageQueryName = customer-profile.CouponDetPageQueryGET -%}
	{% assign paginationPageCount = customer-profile.CouponDetails.PageCount -%}
    {% assign paginationPageNo = customer-profile.CouponDetails.PageNo -%}
    {% assign template = 'partials/customer-profile/discounts/coupon-elements.html' -%}
    {% assign templateContainer = '.coupon-elements-js' -%}
	{% assign tab = 'coupon-details' -%}
    {% assign id = customer-profile.CouponDetails.Id -%}
	{% assign couponString = customer-profile.CouponQueryGET -%}
{% elseif page.QueryString contains 'tab=discount-details' -%}
	{% assign pageQueryName = customer-profile.DiscountDetPageQueryGET -%}
	{% assign paginationPageCount = customer-profile.DiscountERPDetails.PageCount -%}
    {% assign paginationPageNo = customer-profile.DiscountERPDetails.PageNo -%}
    {% assign template = 'partials/customer-profile/discounts/discount-elements.html' -%}
    {% assign templateContainer = '.discount-elements-js' -%}
	{% assign tab = 'discount-details' -%}
    {% assign id = customer-profile.DiscountERPDetails.Id -%}
	{% assign discountString = customer-profile.DiscountQueryGET -%}
{% elseif page.QueryString contains 'tab=active-orders' -%}
	{% assign pageQueryName = customer-profile.OrdersActive.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.OrdersActive.PageCount -%}
	{% assign paginationPageNo = customer-profile.OrdersActive.PageNo -%}
	{% assign template = 'partials/customer-profile/orders/orders-list.html' -%}
	{% assign templateContainer = '.orders-js' -%}
	{% assign tab = 'active-orders' -%}
{% elseif page.QueryString contains 'tab=executed-orders' -%}
	{% assign pageQueryName = customer-profile.OrdersExecuted.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.OrdersExecuted.PageCount -%}
	{% assign paginationPageNo = customer-profile.OrdersExecuted.PageNo -%}
	{% assign template = 'partials/customer-profile/orders/orders-list.html' -%}
	{% assign templateContainer = '.orders-js' -%}
	{% assign tab = 'executed-orders' -%}
{% elseif page.QueryString contains 'tab=inquiries' -%}
	{% assign pageQueryName = customer-profile.Inquiries.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Inquiries.PageCount -%}
	{% assign paginationPageNo = customer-profile.Inquiries.PageNo -%}
	{% assign template = 'partials/customer-profile/inquiries/inquiries-list.html' -%}
	{% assign templateContainer = '.inquiries-js' -%}
	{% assign tab = 'inquiries' -%}
{% elseif page.QueryString contains 'tab=inquiry-details' -%}
	{% assign pageQueryName = customer-profile.OfferDetPageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Offer.PageCount -%}
	{% assign paginationPageNo = customer-profile.Offer.PageNo -%}
	{% assign template = 'partials/order/products-partials/products.html' -%}
	{% assign templateContainer = '.order-products-list-js' -%}
	{% assign tab = 'inquiry-details' -%}
	{% assign id = customer-profile.Offer.Id -%}
	{% assign orderString = customer-profile.OfferQueryGET -%}
{% elseif page.QueryString contains 'tab=offers' -%}
	{% assign pageQueryName = customer-profile.Offers.PageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Offers.PageCount -%}
	{% assign paginationPageNo = customer-profile.Offers.PageNo -%}
	{% assign template = 'partials/customer-profile/offers/offers-list.html' -%}
	{% assign templateContainer = '.offers-js' -%}
	{% assign tab = 'offers' -%}
{% elseif page.QueryString contains 'tab=offer-details' -%}
	{% assign pageQueryName = customer-profile.OfferDetPageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Offer.PageCount -%}
	{% assign paginationPageNo = customer-profile.Offer.PageNo -%}
	{% assign template = 'partials/order/products-partials/products.html' -%}
	{% assign templateContainer = '.order-products-list-js' -%}
	{% assign tab = 'offer-details' -%}
	{% assign id = customer-profile.Offer.Id -%}
	{% assign orderString = customer-profile.OfferQueryGET -%}
{% elseif page.QueryString contains 'tab=order-details' or page.QueryString contains 'tab=active-order-details' or page.QueryString contains 'tab=executed-order-details' or page.QueryString contains 'orderHash' -%}
	{% assign pageQueryName = customer-profile.OrderDetPageQueryGET -%}
	{% assign paginationPageCount = customer-profile.Order.PageCount -%}
    {% assign paginationPageNo = customer-profile.Order.PageNo -%}
    {% assign template = 'partials/order/products-partials/products.html' -%}
    {% assign templateContainer = '.order-products-list-js' -%}
	{% if page.QueryString contains 'tab=order-details' or page.QueryString contains 'orderHash' -%}
		{% assign tab = 'order-details' -%}
	{% elseif page.QueryString contains 'tab=active-order-details' -%}
		{% assign tab = 'active-order-details' -%}
	{% elseif page.QueryString contains 'tab=executed-order-details' -%}
		{% assign tab = 'executed-order-details' -%}
	{% endif -%}
    {% assign id = customer-profile.Order.Id -%}
	{% assign orderString = customer-profile.OrderQueryGET -%}
{% elseif page.QueryString contains 'tab=eshop-orders' or page.PageId == config.DefinedPages.CustomerProfile.Id -%}
	{% if config.B2B %}
		{% assign pageQueryName = customer-profile.Orders.PageQueryGET -%}
		{% assign paginationPageCount = customer-profile.Orders.PageCount -%}
		{% assign paginationPageNo = customer-profile.Orders.PageNo -%}
		{% assign tab = 'eshop-orders' -%}
	{% else -%}
		{% assign pageQueryName = customer-profile.OrdersActive.PageQueryGET -%}
		{% assign paginationPageCount = customer-profile.OrdersActive.PageCount -%}
		{% assign paginationPageNo = customer-profile.OrdersActive.PageNo -%}
		{% assign tab = 'active-orders' -%}
	{% endif -%}
	{% assign template = 'partials/customer-profile/orders/orders-list.html' -%}
	{% assign templateContainer = '.orders-js' -%}
{% endif -%}

{% if paginationPageCount > 1 -%}
    {% capture url -%}{{page.Url}}{% endcapture -%}
    {% if products.Search -%}
	    {% capture url -%}{{products.Search.Url}}{% endcapture -%}
    {% endif -%}

	{% if blog.PostList.Search -%}
	    {% capture url -%}{{blog.PostList.Search.Url}}{% endcapture -%}
    {% endif -%}

    {% if products.SelectedSorting and products.SelectedSorting != 1 -%}
	    {% if url contains '?' -%}
	        {% capture url -%}{{url}}&sort={{products.SelectedSorting}}{% endcapture -%}
	    {% else -%}
	        {% capture url -%}{{url}}?sort={{products.SelectedSorting}}{% endcapture -%}
	    {% endif -%}
	{% endif -%}

	{% if page.QueryString contains 'tab=wishlist' and customer-profile.WishListsPagination.SelectedSorting and customer-profile.WishListsPagination.SelectedSorting != 1 -%}
		{% if url contains '?' -%}
			{% capture url -%}{{url}}&wishListsSortType={{customer-profile.WishListsPagination.SelectedSorting}}{% endcapture -%}
		{% else -%}
			{% capture url -%}{{url}}?wishListsSortType={{customer-profile.WishListsPagination.SelectedSorting}}{% endcapture -%}
		{% endif -%}
	{% endif -%}

	
	{% if page.QueryString contains 'tab=discount-details' -%}
	    {% if url contains '?' -%}
		    {% capture url -%}{{url}}&{{ discountString | H }}={{id}}{% endcapture -%}
	    {% else -%}
		    {% capture url -%}{{url}}?{{ discountString | H }}={{id}}{% endcapture -%}
	    {% endif -%}
	{% endif -%}

	{% if page.QueryString contains 'tab=coupon-details' -%}
	    {% if url contains '?' -%}
		    {% capture url -%}{{url}}&{{ couponString | H }}={{id}}{% endcapture -%}
	    {% else -%}
		    {% capture url -%}{{url}}?{{ couponString | H }}={{id}}{% endcapture -%}
	    {% endif -%}
	{% endif -%}

    {% if page.QueryString contains 'tab=order-details' or page.QueryString contains 'tab=active-order-details' or page.QueryString contains 'tab=executed-order-details' or page.QueryString contains 'tab=inquiry-details' or page.QueryString contains 'tab=offer-details' or page.QueryString contains 'orderHash' -%}
	    {% if url contains '?' -%}
		    {% capture url -%}{{url}}&{{ orderString | H }}={{id}}{% endcapture -%}
	    {% else -%}
		    {% capture url -%}{{url}}?{{ orderString | H }}={{id}}{% endcapture -%}
	    {% endif -%}
	{% endif -%}

	{% if page.QueryString contains 'orderHash' -%}
		    {% capture url -%}{{url}}&orderHash={{page.GET.orderHash}}{% endcapture -%}
	{% endif -%}

	{% if tab -%}
		{% if url contains '?' -%}
		    {% capture url -%}{{url}}&tab={{ tab }}{% endcapture -%}
	    {% else -%}
		    {% capture url -%}{{url}}?tab={{ tab }}{% endcapture -%}
	    {% endif -%}
	{% endif -%}

	{% if additionalSubquery -%}
		{% if  url contains '?' -%}
				{% capture url -%}{{url}}&{{currentSubqueryName}}={{ currentSubqueryValue }}{% endcapture -%}
		{% else -%}
			{% capture url -%}{{url}}?{{currentSubqueryName}}={{ currentSubqueryValue }}{% endcapture -%}
		{% endif -%}
	{% endif -%}

	{% if  url contains '?' -%}
	    {% capture url -%}{{url}}&{{pageQueryName}}={% endcapture -%}
    {% else -%}
	    {% capture url -%}{{url}}?{{pageQueryName}}={% endcapture -%}
    {% endif -%}
{% endif -%}

{% assign prevPage = paginationPageNo | Minus: 1 %}
{% assign nextPage = paginationPageNo | Plus: 1 %}
{% assign paginationStart = paginationPageNo | Minus: 1 %}
{% assign paginationEnd = paginationPageNo | Plus: 1 %}
{% assign paginationLessPages = paginationPageNo | Plus: 1 %}
{% assign paginationMorePages = paginationPageNo | Plus: 2 %}

{% if paginationPageNo == 1 %}
  {% assign paginationStart = 1 %}
  {% assign paginationEnd = 3 %}
{% endif %}

{% if paginationPageNo == paginationPageCount %}
  {% assign paginationStart = paginationPageCount | Minus: 2 %}
  {% assign paginationEnd = paginationPageCount %}
{% endif %}

{% if paginationPageCount > 1 %}
<nav>

    <ul class="pagination-form-js pagination pagination-js" data-template="{{ template }}" data-container="{{ templateContainer }}">  
      <button aria-label="{{ translations.Prev }}" type="button" class="change-quantity-button {% if products.PageQueryGET -%} routing-replace-template-js {% else -%} replace-template-js {% endif -%}" data-url="{{ url | H }}{{ prevPage }}" {% if paginationPageNo == 1 %} disabled {% endif %}>
        <svg class="svgIcon" style="transform: rotate(180deg); margin-right: 12px"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use></svg><span>{{ translations.Prev }}</span>
      </button>
      <li>
        <button type="button" class="change-quantity {% if paginationPageNo == 1 %} change-quantity__active {% endif %} {% if products.PageQueryGET -%} routing-replace-template-js {% else -%} replace-template-js {% endif -%}" data-url="{{ url | H }}1">
          1
        </button>
      </li>
    {% if paginationStart > 2 %}
        <li>...</li>
    {% endif %}
    {% for i in (paginationStart..paginationEnd) %}
        {% if i > 1 and i < paginationPageCount %}
          <li>
            <button type="button" class="change-quantity {% if paginationPageNo == i %} change-quantity__active {% endif %} {% if products.PageQueryGET -%} routing-replace-template-js {% else -%} replace-template-js {% endif -%}" data-url="{{ url | H }}{{ i }}">
            {{ i }}
            </button>
          </li>
        {% endif %}
    {% endfor %}
	{% if paginationPageCount < 5 -%}
		{% if paginationlessPages < paginationPageCount -%}
		<li>...</li>
		{% endif -%}
	{% else -%}
		{% if paginationMorePages < paginationPageCount -%}
		<li>...</li>
		{% endif -%}
    {% endif -%}
      <li>
        <button type="button" class="change-quantity {% if paginationPageNo == paginationPageCount %} change-quantity__active {% endif %} {% if products.PageQueryGET -%} routing-replace-template-js {% else -%} replace-template-js {% endif -%}" data-url="{{ url | H }}{{ paginationPageCount }}">
    {{ paginationPageCount }}
        </button>
      </li>
      <button aria-label="{{ translations.Next }}" type="button" class="change-quantity-button {% if products.PageQueryGET -%} routing-replace-template-js {% else -%} replace-template-js {% endif -%}" data-url="{{ url | H }}{{ nextPage }}" {% if paginationPageNo == paginationPageCount %} disabled {% endif %}>
    	<span>{{ translations.Next }}</span>
		<svg class="svgIcon" style="margin-left: 12px"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}"></use></svg>
      </button>
    </ul>
</nav>
{% endif %}
`